import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';
import { Projectile } from '../entities/projectile';
import { getGameRNG } from '../core/rng';
import { computeSafeSpawnPosition } from './spawnHelper';

const MORTAR_PHYSICS = {
  EXPLOSION_RADIUS: 30,
  MAX_DAMAGE: 25,
  CLUSTER_COUNT: 4,
  CLUSTER_RADIUS: 25,
  CLUSTER_DAMAGE: 20,
};

export const WeaponMortar: WeaponDefinition = {
  id: 'mortar',
  name: 'Mortar',
  icon: 'mortar.1.png',
  category: 'projectile',
  maxAmmo: -1,
  maxUsesPerTurn: 1,
  powerCharging: false,
  timerAdjustable: false,
  showAimGuide: true,
  allowRetreat: true,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm, angle, power, world } = ctx;

    const maxSpeed = 750;
    const speed = (power / 100) * maxSpeed;
    const rad = (angle * Math.PI) / 180;
    const aimRad = worm.facing === 'right' ? rad : Math.PI - rad;

    const spawnDistance = 20;
    const spawn = computeSafeSpawnPosition(worm, aimRad, spawnDistance, world);

    const mortar = new Projectile({
      x: spawn.x,
      y: spawn.y,
      vx: Math.cos(aimRad) * speed,
      vy: -Math.sin(aimRad) * speed,
      type: 'mortar',
      timer: -1,
      bounceH: 0,
      bounceV: 0,
      windAffected: true,
      explosionRadius: MORTAR_PHYSICS.EXPLOSION_RADIUS,
      maxDamage: MORTAR_PHYSICS.MAX_DAMAGE,
      ownerId: worm.id,
    });

    mortar.onExplode = (x, y) => {
      spawnMortarClusters(x, y, worm.id, world);
    };

    return {
      success: true,
      entities: [mortar],
    };
  },
};

function spawnMortarClusters(
  x: number,
  y: number,
  ownerId: string,
  world: WeaponContext['world'],
): void {
  const count = MORTAR_PHYSICS.CLUSTER_COUNT;
  const rng = getGameRNG();

  for (let i = 0; i < count; i++) {
    const spreadAngle = -Math.PI / 2 + (Math.PI * 0.6 * (i / (count - 1)) - Math.PI * 0.3);
    const speed = rng.nextFloat(100, 200);

    const cluster = new Projectile({
      x: x,
      y: y,
      vx: Math.cos(spreadAngle) * speed,
      vy: Math.sin(spreadAngle) * speed - 80,
      type: 'clusterlet',
      timer: -1,
      bounceH: 0,
      bounceV: 0,
      windAffected: false,
      explosionRadius: MORTAR_PHYSICS.CLUSTER_RADIUS,
      maxDamage: MORTAR_PHYSICS.CLUSTER_DAMAGE,
      ownerId: ownerId,
    });

    world.addEntity(cluster);
  }
}
